/**
 * Centralized application configuration
 * Single source of truth for environment-dependent values
 */

function getApiUrl(): string {
  const url = import.meta.env.VITE_API_URL;
  if (url) return url;

  // Allow localhost fallback only in development
  if (import.meta.env.DEV) {
    return "http://localhost:8787";
  }

  // Return empty string instead of throwing — prevents white-screen crash.
  // Features that need the API will fail gracefully at the network level.
  return "";
}

export const API_URL = getApiUrl();
